export default __webpack_public_path__ + "static/media/GIRAFAS200X200.670246c9.png";